import { render, staticRenderFns } from "./EntryGrade.vue?vue&type=template&id=3888239a&"
import script from "./EntryGrade.vue?vue&type=script&lang=js&"
export * from "./EntryGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_qqg2mlm7tcp4cjng2lo6klgciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports